import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const VendorQuotesApiResources = {
  search:  createUrl('module/vendor_quote'),
  searchByVendor:  createUrl('vendor-quotes/search'),

  /**
   * Upload Vendor Quote — the draft endpoints. Every one is nested under its bid, so a draft id
   * alone is never enough to reach a row.
   */
  extractions: (bidId: number) => createUrl(`bids/${bidId}/vendor-quote-extractions`),
  extraction: (bidId: number, id: number) => createUrl(`bids/${bidId}/vendor-quote-extractions/${id}`),
  extractionStatus: (bidId: number, id: number) => createUrl(`bids/${bidId}/vendor-quote-extractions/${id}/status`),
  extractionVendor: (bidId: number, id: number) => createUrl(`bids/${bidId}/vendor-quote-extractions/${id}/vendor`),
  extractionSave: (bidId: number, id: number) => createUrl(`bids/${bidId}/vendor-quote-extractions/${id}/save`),

  /** Vendor quotes on a proposal scope: Compare (preview), Apply, Undo, and the apply still in effect. */
  scopeQuotesPreview: (scopeId: number) => createUrl(`proposal-scopes/${scopeId}/vendor-quotes/preview`),
  scopeQuotesApply: (scopeId: number) => createUrl(`proposal-scopes/${scopeId}/vendor-quotes/apply`),
  scopeQuotesUndo: (scopeId: number) => createUrl(`proposal-scopes/${scopeId}/vendor-quotes/undo`),
  scopeQuotesLast: (scopeId: number) => createUrl(`proposal-scopes/${scopeId}/vendor-quotes/last`),
  /** Every apply still in effect on the scope — the Apply dialog's "Applied" rows with Undo. */
  scopeQuotesApplications: (scopeId: number) => createUrl(`proposal-scopes/${scopeId}/vendor-quotes/applications`),

  /** The same four on a change order scope. */
  coScopeQuotesPreview: (scopeId: number) => createUrl(`change/orders/scopes/${scopeId}/vendor-quotes/preview`),
  coScopeQuotesApply: (scopeId: number) => createUrl(`change/orders/scopes/${scopeId}/vendor-quotes/apply`),
  coScopeQuotesUndo: (scopeId: number) => createUrl(`change/orders/scopes/${scopeId}/vendor-quotes/undo`),
  coScopeQuotesLast: (scopeId: number) => createUrl(`change/orders/scopes/${scopeId}/vendor-quotes/last`),
  coScopeQuotesApplications: (scopeId: number) => createUrl(`change/orders/scopes/${scopeId}/vendor-quotes/applications`),
};
